<template>
    <div class="main-menu-submenu__col expanded-menu-item">
        <template v-if="activeExpandItem && activeExpandItem.subMenu.length">
            <p class="text-uppercase text-grey mb-24">
                {{ activeExpandItem.title }}
            </p>
            <div class="expanded-menu-item__list">
                <template v-for="expanditem in activeExpandItem.subMenu">
                    <span
                        v-if="!expanditem.isExternal && expanditem.isActive"
                        :key="expanditem.slug || expanditem.path"
                        class="main-menu-submenu__link"
                        @click="sameLinkEventHandler(getLink(expanditem))"
                    >
                        <n-link
                            :to="getLink(expanditem)"
                            :class="[
                                {
                                    green: expanditem.green,
                                    active: isLinkActive(getLink(expanditem))
                                }
                            ]"
                        >
                            {{ expanditem.title }}
                        </n-link>
                    </span>
                    <a
                        v-else
                        :key="expanditem.slug || expanditem.path"
                        :href="getLink(expanditem)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="main-menu-submenu__link"
                    >
                        {{ expanditem.title }}
                    </a>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import {useMainMenu} from '@/core/composables/useMainMenu';

export default defineComponent({
    name: 'TheMainMenuExpandedItem',
    setup() {
        const menuComposable = useMainMenu();

        return {
            activeExpandItem: menuComposable.activeExpandItem,
            getLink: menuComposable.getLink,
            sameLinkEventHandler: menuComposable.sameLinkEventHandler,
            isLinkActive: menuComposable.isLinkActive,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/navigation/mainMenu';
</style>
